import React, { useEffect, useRef, useState } from "react";
import { Popup } from "witmeg-ui-system";
import "./ScheduleOrderModal.scss"
import close from "../../../assets/close.svg"
import { useSelector } from "react-redux";
import moment from "moment";
import arrowBlack from "../../../assets/arrow-black.svg"

const ScheduleOrderModal = ({ visibility, onPopupClose, setOrderSchedule, setSelectedOrderTime, showChancel = true, setSelectedOrderDate }) => {
    const preparationSettings = useSelector((state) => state.companyData.preparationSettings);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const {
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const containerRef = useRef(null);

    const getNext7Days = () => {
        const days = [];
        const today = new Date();

        for (let i = 0; i < 7; i++) {
            const nextDate = new Date(today);
            nextDate.setDate(today.getDate() + i);
            days.push(nextDate.toISOString().split('T')[0]);
        }

        return days;
    };
    const [interval, setInterval] = useState(30);

    const [showRightArrow, setShowRightArrow] = useState(true);
    const [showLeftArrow, setShowLeftArrow] = useState(false);


    const scrollRight = () => {
        containerRef.current?.scrollBy({ left: 330, behavior: 'smooth' });
    };

    const scrollLeft = () => {
        containerRef.current?.scrollBy({ left: -330, behavior: 'smooth' });
    };
    useEffect(() => {
        const scrollContainerSched = containerRef.current;
        if (scrollContainerSched) {
            const handleScroll = () => {
                const { scrollLeft, scrollWidth, clientWidth } = scrollContainerSched;
                setShowLeftArrow(scrollLeft > 0);
                setShowRightArrow(scrollLeft + clientWidth + 20 < scrollWidth);
            };

            handleScroll();

            scrollContainerSched.addEventListener("scroll", handleScroll);
            window.addEventListener("resize", handleScroll);

            return () => {
                scrollContainerSched.removeEventListener("scroll", handleScroll);
                window.removeEventListener("resize", handleScroll);
            };
        }
    }, []);
    const [scheduleOrder, setScheduleOrder] = useState(localStorage.getItem("schedule_order") ? localStorage.getItem("schedule_order") : JSON.stringify({
        StartTime: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss[Z]'),
        EndTime: moment(new Date(new Date().getTime() + interval * 60 * 1000)).format('YYYY-MM-DDTHH:mm:ss[Z]'),
    }));
    const getFullfillmentType = () => {
        let type
        switch (selectedOrderType) {
            case "delivery":
                type = "DELIVERY_BY_REWARDCONSUMER"
                break;
            case "collection":
                type = "TAKE_AWAY"
                break;
            case "table":
                type = "DINE_IN"
                break;
            default:
                type = "DELIVERY_BY_REWARDCONSUMER"
                break;
        }
        return type
    }
    const isNowNotWithinOpenHours = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });

        const todaySchedule = companyDetails?.openingHours.find(day => day.Day === currentDay);
        if (!todaySchedule || todaySchedule.Closed || !todaySchedule.OpenHours.length) {
            return false;
        }
        let time = {
            StartTime: todaySchedule.OpenHours[0].StartTime,
            EndTime: todaySchedule.OpenHours[todaySchedule.OpenHours.length - 1].EndTime
        }

        return time;
    }
    const isOverlapping = (start1, end1, start2, end2) => {
        return start1.isBefore(end2) && end1.isAfter(start2);
    };
    const [selectedDate, setSelectedDate] = useState(getNext7Days()[0])
    const getTodayIntervals = () => {
        const now = moment();
        const date = moment(selectedDate);
        const isToday = date.isSame(now, 'day');
        const currentDay = date.format('dddd');
        const blockedTimes = companyDetails?.settings?.OnlineOrder?.BlockedHours
        const orderSettings =
            selectedOrderType === "delivery"
                ? companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.Delivery
                : selectedOrderType === "collection"
                    ? companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.Takeaway
                    : companyDetails?.settings?.OnlineOrder?.OrderAcceptance?.DineIn;

        const todaySchedule = orderSettings?.find(d => d.Day === currentDay);
        if (!todaySchedule || todaySchedule.Closed) return [];

        const intervals = [];

        todaySchedule.OpenHours.forEach(({ StartTime, EndTime }) => {
            let start = moment(StartTime, 'HH:mm').set({
                year: date.year(),
                month: date.month(),
                date: date.date(),
            });
            let end = moment(EndTime, 'HH:mm').set({
                year: date.year(),
                month: date.month(),
                date: date.date(),
            });

            if (end.isBefore(start)) {
                end.add(1, 'day');
            }

            const endOfDay = moment(date).endOf('day').set({ second: 59 });

            if (end.isAfter(endOfDay)) {
                end = endOfDay;
            }
            const time = preparationSettings?.Durations?.find(
                (duration) =>
                    duration.OrderType === getFullfillmentType() &&
                    duration.Schedule === 'STANDARD'
            );
            const intervalVal = time?.DurationInMin || interval
            while (start.isBefore(end)) {
                const next = moment(start).add(intervalVal, 'minutes');
                if (next.isAfter(end)) break;

                if (isToday && start.isSameOrBefore(now)) {
                    start = next;
                    continue;
                }

                intervals.push({
                    StartTime: start.clone(),
                    EndTime: next.clone(),
                });

                start = next;
            }
        });

        const todayBlocked = blockedTimes.find(b => b.Day === currentDay)?.Time || [];
        const filteredIntervals = intervals.filter(({ StartTime, EndTime }) => {
            const intervalStart = moment(StartTime);
            const intervalEnd = moment(EndTime);
            return !todayBlocked.some(({ StartTime: bStart, EndTime: bEnd }) => {
                const blockedStart = moment(bStart, 'HH:mm').set({
                    year: date.year(),
                    month: date.month(),
                    date: date.date(),
                });
                const blockedEnd = moment(bEnd, 'HH:mm').set({
                    year: date.year(),
                    month: date.month(),
                    date: date.date(),
                });
                return isOverlapping(intervalStart, intervalEnd, blockedStart, blockedEnd);
            });
        });
        return filteredIntervals.map(({ StartTime, EndTime }) => ({
            StartTime: StartTime.format('HH:mm'),
            EndTime: EndTime.format('HH:mm'),
        }))
    };
    const [selectedTime, setSelectedTime] = useState(getTodayIntervals()[0])
    useEffect(() => {
        let schedTime = localStorage.getItem("schedule_order")
        if (schedTime) {
            let timeSched = JSON.parse(localStorage.getItem("schedule_order"))
            let dateP = timeSched?.StartTime?.split('T');
            setSelectedDate(dateP[0])
            setScheduleOrder(schedTime)

        } else {
            setSelectedTime(getTodayIntervals()[0])
            let scheduletime = {
                StartTime: `${selectedDate}T${getTodayIntervals()[0]?.StartTime}:00.000Z`,
                EndTime: `${selectedDate}T${getTodayIntervals()[0]?.EndTime}:00.000Z`,
            }
            setScheduleOrder(JSON.stringify(scheduletime))
        }
    }, [])
    useEffect(() => {
        let schedTime = localStorage.getItem("schedule_order")
        if (schedTime) {
            let timeSched = JSON.parse(localStorage.getItem("schedule_order"))
            let [datePart, timePartWithMsStart] = timeSched?.StartTime?.split('T');
            let [datePartEnd, timePartWithMsEnd] = timeSched?.EndTime?.split('T');
            const timePartStart = timePartWithMsStart?.slice(0, 5);
            const timePartEnd = timePartWithMsEnd?.slice(0, 5);
            if (datePart === selectedDate) {
                setSelectedTime({
                    StartTime: timePartStart,
                    EndTime: timePartEnd
                })
                setScheduleOrder(schedTime)
            } else {
                setSelectedTime(getTodayIntervals()[0])
                let scheduletime = {
                    StartTime: `${selectedDate}T${getTodayIntervals()[0]?.StartTime}:00.000Z`,
                    EndTime: `${selectedDate}T${getTodayIntervals()[0]?.EndTime}:00.000Z`,
                }
                setScheduleOrder(JSON.stringify(scheduletime))
            }

        } else {
            setSelectedTime(getTodayIntervals()[0])
            let scheduletime = {
                StartTime: `${selectedDate}T${getTodayIntervals()[0]?.StartTime}:00.000Z`,
                EndTime: `${selectedDate}T${getTodayIntervals()[0]?.EndTime}:00.000Z`,
            }
            setScheduleOrder(JSON.stringify(scheduletime))

        }
    }, [selectedDate])
    useEffect(() => {
        if (preparationSettings) {
            const time = preparationSettings?.Durations?.find(
                (duration) =>
                    duration.OrderType === getFullfillmentType() &&
                    duration.Schedule === 'STANDARD'
            );
            if (time) {
                setInterval(time.DurationInMin)
                let schedTime = localStorage.getItem("schedule_order")
                if (schedTime) {
                    let timeSched = JSON.parse(localStorage.getItem("schedule_order"))
                    let [datePart, timePartWithMsStart] = timeSched?.StartTime?.split('T');
                    let [datePartEnd, timePartWithMsEnd] = timeSched?.EndTime?.split('T');
                    const timePartStart = timePartWithMsStart?.slice(0, 5);
                    const timePartEnd = timePartWithMsEnd?.slice(0, 5);
                    if (datePart === selectedDate) {
                        setSelectedTime({
                            StartTime: timePartStart,
                            EndTime: timePartEnd
                        })
                    } else {
                        setSelectedTime(getTodayIntervals()[0])
                        let scheduletime = {
                            StartTime: `${selectedDate}T${getTodayIntervals()[0]?.StartTime}:00.000Z`,
                            EndTime: `${selectedDate}T${getTodayIntervals()[0]?.EndTime}:00.000Z`,
                        }
                        setScheduleOrder(JSON.stringify(scheduletime))
                    }

                } else {
                    setSelectedTime(getTodayIntervals()[0])
                    let scheduletime = {
                        StartTime: `${selectedDate}T${getTodayIntervals()[0]?.StartTime}:00.000Z`,
                        EndTime: `${selectedDate}T${getTodayIntervals()[0]?.EndTime}:00.000Z`,
                    }
                    setScheduleOrder(JSON.stringify(scheduletime))
                }
            }
        }
    }, [preparationSettings, selectedDate])
    const getOrderType = () => {
        let type
        switch (selectedOrderType) {
            case "delivery":
                type = "Delivery"
                break;
            case "collection":
                type = "Collection"
                break;
            case "table":
                type = "Order"
                break;
            default:
                type = "Delivery"
                break;
        }
        return type
    }


    return (
        <Popup
            className='ScheduleOrderModal'
            modalVisible={visibility}
            modalTitle=""
            mask={true}
            centered
            onCancel={() => {
                onPopupClose()
            }}
            closable={false}>
            <div className="modal-inner">
                <div className="modal-inner-header-container">
                    <div className="modal-inner-header-wrapper">
                        <div className="modal-inner-title-text">
                            Schedule {getOrderType()}
                        </div>
                        <img className="close-icon" alt="" src={close}
                            onClick={() => {
                                onPopupClose()
                            }} />
                    </div>
                    <div className="modal-inner-sub-text">Our store is currently closed for orders.Opens at {moment(isNowNotWithinOpenHours()?.StartTime, "HH:mm").format('hh:mm A')} </div>
                </div>
                <div className="modal-inner-container">
                    <div className="date-list-cont">
                        {showLeftArrow && <div
                            onClick={scrollLeft}
                            className={`arrow-left`}
                        >
                            <img alt="" src={arrowBlack} />

                        </div>}
                        <div className="date-picker-list" ref={containerRef}>

                            {getNext7Days().map((day, key) => {
                                const selected = selectedDate === day
                                const date = moment(day);
                                const today = moment();
                                const isToday = date.isSame(today, 'day');
                                const isTomorrow = date.isSame(today.clone().add(1, 'day'), 'day');
                                return (
                                    <div key={key} className={`date-picker-list-item ${selected ? "selected" : ""}`}
                                        onClick={() => {
                                            setSelectedDate(day)
                                        }}>
                                        <div className="date-picker-list-item-header">{isToday
                                            ? 'Today'
                                            : isTomorrow
                                                ? 'Tomorrow'
                                                : date.format('ddd')}</div>
                                        <div className="date-picker-list-item-sub">
                                            {date.format('MMM DD')}</div></div>
                                )
                            })}

                        </div>
                        {showRightArrow && <div
                            onClick={scrollRight}
                            className={`arrow-right`}
                        >
                            <img alt="" src={arrowBlack} />

                        </div>}
                    </div>
                    <div className="time-container">
                        {getTodayIntervals().map((time) => {
                            const selected = JSON.stringify(selectedTime) === JSON.stringify(time)
                            return (
                                <div className="time-container-item"
                                    onClick={() => {
                                        setSelectedTime(time)
                                        let scheduletime = {
                                            StartTime: `${selectedDate}T${time.StartTime}:00.000Z`,
                                            EndTime: `${selectedDate}T${time.EndTime}:00.000Z`,
                                        }
                                        setScheduleOrder(JSON.stringify(scheduletime))
                                    }}>
                                    {moment(time?.StartTime, "HH:mm").format('hh:mm A')} - {moment(time?.EndTime, "HH:mm").format('hh:mm A')}
                                    {selected ? <div className="radio-outer"><div className="select" /></div> : <div className="radio-outer-unselect" />}
                                </div>
                            )
                        })}
                    </div>
                    <div className="btn-container"
                        onClick={() => {
                            localStorage.setItem("schedule_order", scheduleOrder)
                            if (setOrderSchedule) {
                                let timeSched = JSON.parse(scheduleOrder)
                                let [datePart, timePartWithMsStart] = timeSched?.StartTime?.split('T');
                                let [datePartEnd, timePartWithMsEnd] = timeSched?.EndTime?.split('T');
                                const timePartStart = timePartWithMsStart?.slice(0, 5);
                                const timePartEnd = timePartWithMsEnd?.slice(0, 5);
                                if (datePart === selectedDate) {
                                    let dateP = timeSched?.StartTime?.split('T');
                                    if (setSelectedOrderDate) {
                                        setSelectedOrderDate(dateP[0])
                                    }
                                    if (setSelectedOrderTime) {
                                        setSelectedOrderTime({
                                            StartTime: timePartStart,
                                            EndTime: timePartEnd
                                        })
                                    }
                                    setOrderSchedule(scheduleOrder)
                                }
                            }
                            onPopupClose()
                        }}>
                        Schedule
                    </div>
                    {showChancel && <div className="btn-container-cancel"
                        onClick={() => {
                            localStorage.removeItem("schedule_order")
                            onPopupClose()
                        }}>
                        Cancel
                    </div>
                    }

                </div></div>
        </Popup>
    )
}
export default ScheduleOrderModal